import { FC } from "react";
import { CreateClientDeliverablesRowValue } from "../../modelsAndSchemas/models";
import { CreateClientDeliverable } from "../createDeliverable/CreateDeliverable";

interface EditDeliverableProps {
  handleCloseModal: () => void;
  pageId: string;
  show: boolean;
  selectedDeliverables: CreateClientDeliverablesRowValue;
  callApiFunction: () => void;
}

export const EditDeliverable: FC<EditDeliverableProps> = ({
  show,
  pageId,
  handleCloseModal,
  selectedDeliverables,
  callApiFunction,
}) => {
  return (
    <CreateClientDeliverable
      show={show}
      handleCloseModal={handleCloseModal}
      pageId={pageId}
      getListOfDeliverablesApi={callApiFunction}
      isEditDeliverable={true}
      deliverableId={selectedDeliverables?.id}
    />
  );
};
